<template>
  <div class="flex overflow-hidden">
    <div class="hidden lg:flex lg:flex-shrink-0">
      <div class="flex flex-col w-100 border-r border-gray-200 bg-gray-100">
        <flow-sidebar v-if="blueprints !== {}" :blueprints="blueprints" :index="selectedBlueprint.id"/>
      </div>
    </div>
    <div class="flex flex-col w-0 flex-1 pl-4 overflow-hidden">
      <div class="flex flex-col bg-white rounded-lg">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-blocksm:px-6 lg:px-8">
            <flow-dynamic-table v-if="selectedBlueprint !== {}" :blueprint="selectedBlueprint"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FlowSidebar from '@/components/flow/FlowSidebar'
import FlowDynamicTable from '@/components/flow/FlowDynamicTable'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'FlowBase',
  components: { FlowSidebar, FlowDynamicTable },
  data() {
    return {
      selectedBlueprint: {}
    }
  },
  mounted() {
    this.fetchItems()
  },
  computed: {
    ...mapGetters(['blueprints'])
  },
  methods: {
    ...mapActions(['getBlueprints']),

    async fetchItems() {
      await this.getBlueprints()
    },

    selectBlueprint(blueprint) {
      this.selectedBlueprint = blueprint
      console.log(JSON.parse(JSON.stringify(blueprint)))
      this.fetchItems()
    }
  }
}
</script>
